import React, { useState } from 'react'
import { Tooltip, Button } from 'antd'
import { CopyOutlined } from '@ant-design/icons'

interface CopyButtonProps {
  value: string
  children: React.ReactNode
}

export const CopyElement: React.FC<CopyButtonProps> = ({ value, children }) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      // Remove any formatting from CPF (dots and hyphens)
      const cleanValue = value || ''

      if (navigator.clipboard) {
        await navigator.clipboard.writeText(cleanValue)
      } else {
        // Fallback for older browsers
        const textArea = document.createElement('textarea')
        textArea.value = cleanValue
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
      }

      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy CPF:', err)
    }
  }

  return (
    <Tooltip title={copied ? 'Copiado!' : 'Copiar'}>
      <span style={{ cursor: 'pointer' }} onClick={handleCopy}>
        {children}
      </span>
    </Tooltip>
  )
}
